import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.CopyWorkflowPopup.MultipleForm', {
    selectOrganisation: 'Select organisation',
    selectWorkflows: 'Select workflows',
    toCompanyFieldLabel: 'Copy Workflows to Organisation',
});
